export const CONTACT_SOURCE_KEY = 'wcc_contact_from';

export function capturePathBeforeHomeNavigation() {
  if (typeof window === 'undefined') return;
  try {
    const url = `${window.location.origin}${window.location.pathname}${window.location.search}`;
    sessionStorage.setItem(CONTACT_SOURCE_KEY, url.slice(0, 2000));
  } catch (_) {}
}

export function primeContactSourceFromReferrer() {
  if (typeof document === 'undefined' || typeof window === 'undefined') return;
  try {
    if (sessionStorage.getItem(CONTACT_SOURCE_KEY)) return;
  } catch (_) {
    return;
  }
  const ref = document.referrer;
  if (!ref || !ref.startsWith(`${window.location.origin}/`)) return;
  try {
    const u = new URL(ref);
    const path = u.pathname + u.search;
    if (path === '/' || path === '') return;
    sessionStorage.setItem(CONTACT_SOURCE_KEY, u.href.slice(0, 2000));
  } catch (_) {}
}

export function readContactSourceForSubmit() {
  if (typeof window === 'undefined') return '';
  try {
    const v = sessionStorage.getItem(CONTACT_SOURCE_KEY);
    if (v && String(v).trim()) return String(v).trim().slice(0, 2000);
  } catch (_) {}
  return window.location.href.slice(0, 2000);
}

export function clearContactSource() {
  try {
    sessionStorage.removeItem(CONTACT_SOURCE_KEY);
  } catch (_) {}
}
